import { CSSObject } from '@chakra-ui/react';

export const DeductionsText: CSSObject = {
  color: 'alpha.300',
  mb: '1',
};

export const FooterMoreOpenText: CSSObject = {
  color: 'alpha.300',
  fontSize: 'xs',
};

export const BoxMoreText: CSSObject = {
  w: '8',
  color: 'alpha.300',
};

export const FooterBodyText: CSSObject = {
  color: 'blackAlpha.500',
};

export const toteMultiGrid: CSSObject = {
  gridTemplateColumns: 'repeat(2, 1fr)',
  gap: '6',
  display: 'grid',
};

export const toteMultiGridText: CSSObject = {
  fontSize: 'xs',
  w: 'full',
  color: 'alpha.300',
  fontWeight: 'bold',
  mb: '2',
  '&.raceNumber': {
    borderBottom: '1px dashed',
    borderColor: '#00000040',
    boxShadow: '0px 1px 0px 0px #FFFFFF1A',
  },
};